<app-material-utility [headerText$]="headerText$" [headerIcon$]="headerIcon$" [headerIconUrl$]="headerIconUrl$"
[noItemsMessage$]="noItemsMessage$"></app-material-utility>